module.exports = __webpack_public_path__ + "static/img/img_fuwu_001.2ed015f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/img_fuwu_001.png
// module id = gexm
// module chunks = 19